import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Typography from '@mui/material/Typography';


function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function InfoList(props) {
  const informations = props.data.personalInfo;
  const informationItemList = Object.keys(informations).map((key, index) => {
    const itemKey = capitalizeFirstLetter(`${key}:\xa0`);
    const itemValue = `${informations[key]}`;
    return (
      <ListItem disablePadding key={index}>
        <ListItemButton>
          <ListItemIcon
            sx={{
              minWidth: '30px'
            }}
          >
            <KeyboardDoubleArrowRightIcon />
          </ListItemIcon>
          <Typography
            variant="personalInfoItemKey"
            color="customText.dark"
          >
            {itemKey}  
          </Typography>
          <Typography
            color="customText.main"
            variant="personalInfoItemValue"
          >
            {itemValue}
          </Typography>
        </ListItemButton>
      </ListItem>
    )
  })

  return (
    <List>
      {informationItemList}
    </List>
  )
}

export default function SelfInformationList(props) {
  return (
    <Box
      sx={{
      }}
    >
      <Typography
        sx = {{
          fontWeight: 'bold',
          fontSize: '2rem',
        }}
        gutterBottom
        color="customText.dark"
      >
        Personal Info
      </Typography>
      <Divider></Divider>
      <InfoList data={props.data} />
    </Box>
  );
}